import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getContacts } from "store/actions";

import Table from "./Table";

const AdvirtiseType = () => {
  const dispatch = useDispatch();
  const { contacts, loading } = useSelector((state) => state.contacts);

  useEffect(() => {
    dispatch(getContacts());
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <Table data={contacts} loading={loading} />
    </div>
  );
};

export default AdvirtiseType;
